import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp } from 'react-icons/fa';

const PRODUCTS = ['Non-Woven D-Cut Bags','Printed Plastic Carry Bags','Shopping Bags'];
const LINKS = ['Home','About','Products','Gallery','Contact'];

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });

  return (
    <>
      <style>{`
        @media(max-width:900px){
          .footer-grid { grid-template-columns:1fr 1fr !important; }
          .footer-brand-col { grid-column:1/3 !important; }
        }
        @media(max-width:600px){
          .footer-grid { grid-template-columns:1fr !important; gap:32px !important; }
          .footer-brand-col { grid-column:1 !important; }
          .footer-logo-name { font-size:18px !important; }
          .footer-desc { font-size:14px !important; line-height:1.6 !important; }
          .footer-soc-row { justify-content:flex-start !important; }
        }
      `}</style>
    <footer style={s.footer}>
      <div style={s.topLine} />
      <div style={s.container}>
        <div className="footer-grid" style={s.grid}>

          {/* Brand col */}
          <div className="footer-brand-col" style={s.brandCol}>
            <div style={s.logoRow}>
              <div style={s.logoMark}>LP</div>
              <div>
                <div className="footer-logo-name" style={s.logoName}>Laxmi Printers</div>
                <div style={s.logoSub}>HYDERABAD · EST. 2009</div>
              </div>
            </div>
            <p className="footer-desc" style={s.brandDesc}>
              Hyderabad's trusted manufacturer of premium printed carry bags, non-woven bags and printed plastic carry bags. Factory-direct pricing since 2009.
            </p>
            <div className="footer-soc-row" style={s.socRow}>
              <a href="tel:+916302362758" style={{ ...s.socBtn, background: 'rgba(200,137,58,0.1)', border: '1px solid rgba(200,137,58,0.25)', color: '#c8893a', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <FaPhoneAlt /> Call Now
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 style={s.colHead}>Products</h4>
            <ul style={s.list}>
              {PRODUCTS.map(p => <li key={p} style={s.listItem}>{p}</li>)}
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 style={s.colHead}>Navigation</h4>
            <ul style={s.list}>
              {LINKS.map(l => (
                <li key={l} style={{ ...s.listItem, cursor: 'pointer' }} onClick={() => scrollTo(l)}>{l}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 style={s.colHead}>Contact</h4>
            <ul style={s.list}>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaMapMarkerAlt /> Hyderabad, Telangana</li>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaPhoneAlt /> Pradeep: +91 9959650765</li>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaPhoneAlt /> Yashwanth: +91 6302362758</li>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaWhatsapp /> WhatsApp: Yashwanth</li>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaEnvelope /> Email: laxmiprinters6302@gmail.com</li>
              <li style={{ ...s.listItem, display: 'flex', alignItems: 'center', gap: 8 }}><FaClock /> Mon–Sat: 11AM – 8 PM</li>
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div style={s.bottomBar}>
          <div style={s.bottomLine} />
          <div style={s.bottomInner}>
            <span style={s.copy}>© 2025 Laxmi Printers, Hyderabad. All Rights Reserved.</span>
            <span style={s.owners}>Owned by M Pradeep Kumar &amp; M Yashwanth Kumar</span>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}

const s = {
  footer: { background: '#070707', position: 'relative' },
  topLine: { height: 1, background: 'linear-gradient(90deg,transparent,rgba(200,137,58,0.4),transparent)' },
  container: { maxWidth: 1280, margin: '0 auto', padding: '72px 32px 32px' },
  grid: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr', gap: 48, marginBottom: 56 },
  brandCol: {},
  logoRow: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 },
  logoMark: {
    width: 44, height: 44, borderRadius: 10,
    background: 'linear-gradient(135deg,#c8893a,#e8a84a)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 17, color: '#0a0a0a',
  },
  logoName: { fontFamily: "'Cormorant Garamond',serif", fontWeight: 600, fontSize: 19, color: '#f0ede6' },
  logoSub: { fontSize: 9, letterSpacing: 2.5, color: '#c8893a', fontWeight: 600 },
  brandDesc: { fontSize: 13.5, color: 'rgba(240,237,230,0.45)', lineHeight: 1.8, marginBottom: 22 },
  socRow: { display: 'flex', gap: 10, flexWrap: 'wrap' },
  socBtn: {
    padding: '9px 18px', borderRadius: 9, fontSize: 13, fontWeight: 700,
    textDecoration: 'none', transition: 'all 0.25s ease',
  },
  colHead: {
    fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 700,
    color: '#f0ede6', marginBottom: 20, letterSpacing: 0.3,
  },
  list: { listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 },
  listItem: { fontSize: 13.5, color: 'rgba(240,237,230,0.45)', lineHeight: 1.4, transition: 'color 0.2s' },
  mapBtn: {
    marginTop: 18, background: 'rgba(200,137,58,0.1)', border: '1px solid rgba(200,137,58,0.25)',
    color: '#c8893a', borderRadius: 9, padding: '10px 16px',
    fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700, cursor: 'pointer',
    transition: 'all 0.25s ease', width: '100%',
  },
  bottomBar: { borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 24 },
  bottomLine: {},
  bottomInner: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  copy: { fontSize: 12.5, color: 'rgba(240,237,230,0.3)' },
  owners: { fontSize: 12.5, color: 'rgba(240,237,230,0.3)' },
};
